<div class="events-container">
  <div class="filters">
    <div
      class="filter-item"
      [ngClass]="{ active: item.active }"
      *ngFor="let item of filters"
      (click)="handleFilter(item)"
    >
      {{ item.name }}
    </div>
  </div>
  <div class="empty-events" *ngIf="!isPending && events.length === 0">
    {{ I18n.InfoMessages.NoEventsToShow | translate }}
  </div>
  <div class="pending-events" *ngIf="isPending && events.length <= 0"></div>

  <div class="event-list">
    <div
      class="event-item-wrapper"
      [ngClass]="{ 'wrapper-min-height': events.length >= 4 }"
    >
      <div class="event-item" *ngFor="let event of currentPageEvents">
        <div class="main-info">
          <div class="date">
            <div class="month">{{ event.month | uppercase }}</div>
            <div class="day">{{ event.day }}</div>
            <div class="week">{{ event.week | uppercase }}</div>
          </div>
          <div class="info">
            <div class="type">{{ event.typeName }}</div>
            <div class="name">{{ event.name }}</div>
            <div class="duration-time">{{ event.durationTime }}</div>
          </div>
          <div class="type">
            <img *ngIf="event.typeSrc" [src]="event.typeSrc" />
          </div>
        </div>
        <div class="status" [ngClass]="event.status">
          <span *ngIf="event.status === 'open'">
            {{ I18n.Status.Open | translate}}
          </span>
        </div>
      </div>
    </div>
    <div class="pagination" *ngIf="events.length > 0">
      <pagination
        [boundaryLinks]="true"
        [totalItems]="total"
        [itemsPerPage]="pageSize"
        [maxSize]="maxSize"
        [(ngModel)]="currentPage"
        (pageChanged)="onPageChanged($event)"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;"
      >
      </pagination>
    </div>
  </div>
</div>
